import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PainPoints } from '../components/PainPoints';
import { Solution } from '../components/Solution';
import { CourseModules } from '../components/CourseModules';
import { PDFLibrary } from '../components/PDFLibrary';
import { Testimonials } from '../components/Testimonials';
import { Bonuses } from '../components/Bonuses';
import { FAQ } from '../components/FAQ';
import { Pricing } from '../components/Pricing';
import { Guarantee } from '../components/Guarantee';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FDFBF7] font-sans text-[#3D3028] selection:bg-[#E5A5A0] selection:text-white" data-id="element-329">
      <Header data-id="element-330" />
      <Hero data-id="element-331" />
      <PainPoints data-id="element-332" />
      <Solution data-id="element-333" />
      <CourseModules data-id="element-334" />
      <PDFLibrary data-id="element-335" />
      <Testimonials data-id="element-336" />
      <Bonuses data-id="element-337" />
      <FAQ data-id="element-338" />
      <Pricing data-id="element-339" />
      <Guarantee data-id="element-340" />
      <FinalCTA data-id="element-341" />
      <Footer data-id="element-342" />
    </main>;
}